// 빌드 타임 분기 — webpack이 활성 bootstrap 하나만 번들에 포함
if (process.env.REACT_APP_STOCKAI_ONLY === '1') {
  require('./pages/StockAI/components/StockAILayout').mountStockAI();
} else {
  require('./App').mountMain();
}
